import { ContentPopulate } from './contents';
import { PopupApiDto, PopupEventApiType } from './dto';
import { apiRequest, BaseOptions, getBaseOptions, Populate } from './utils/util';

const rootPath = '/v2/popups';

export interface PopupPopulate {
  content?: Populate<ContentPopulate>;
  offer?: boolean;
}

export interface HandlePopupsOptions extends BaseOptions {
  populate: PopupPopulate;
}

export const handlePopups = async <T>(
  event: PopupEventApiType,
  url: string,
  popupsToExclude: Array<string>,
  options?: HandlePopupsOptions
) =>
  apiRequest<Array<PopupApiDto<T>>, void, PopupPopulate>({
    ...getBaseOptions(options),
    params: {
      event,
      popupsToExclude,
      url,
    },
    populate: options?.populate,
    staleTime: Infinity,
    url: `${rootPath}`,
  });

export interface GetPopupByIdOptions extends BaseOptions {
  populate: PopupPopulate;
}

export const getPopupById = async <T>(id: string, options?: GetPopupByIdOptions) =>
  apiRequest<PopupApiDto<T>, void, PopupPopulate>({
    ...getBaseOptions(options),
    populate: options?.populate,
    staleTime: Infinity,
    url: `${rootPath}/${id}`,
  });
